module.exports = __webpack_public_path__ + "media/evolve/assets/icons/floorplans/clock-c143475fc2174a3536f8e2dd96236aa6.svg";